import { getStateLists } from "@/api/myProfile";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const fetchStateData = createAsyncThunk(
  "common/fetchStateData",
  async (_, { getState }) => {
    try {
      const { common } = getState();
      // If we already have state data, don't fetch again
      if (common.stateList.length > 0) {
        return common.stateList;
      }
      // else make an api call to fetch the state
      const response = await getStateLists();
      // Handle various API response shapes
      if (Array.isArray(response)) return response;
      if (Array.isArray(response?.data)) return response.data;
      if (Array.isArray(response?.stateList)) return response.stateList;
      if (Array.isArray(response?.results)) return response.results;
      return [];
    } catch (error) {
      throw error;
    }
  }
);

const initialState = {
  stateList: [],
  loading: false,
  error: null,
};

export const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStateData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStateData.fulfilled, (state, action) => {
        state.loading = false;
        state.stateList = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchStateData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Selectors
export const selectStateList = (state) => {
  const list = state.common.stateList;
  return Array.isArray(list) ? list : [];
};
export const selectStateLoading = (state) => state.common.loading;

export default commonSlice.reducer;
